import { createContext, useContext } from "react";

import { IExtendableDto, RydeUiUnit } from "@ryde/shared";

export interface IBulkEditFormContext {
  entity: RydeUiUnit;
  isBulkEditForm?: boolean;
  selectedRowsValues?: IExtendableDto[];
}

const BulkEditFormContext = createContext<IBulkEditFormContext>({
  entity: "unknown",
  isBulkEditForm: false,
});

BulkEditFormContext.displayName = "BulkEditFormContext";

export const useBulkEditFormContext = (): IBulkEditFormContext =>
  useContext(BulkEditFormContext);

export { BulkEditFormContext };
